import { container } from '@/core/di';
import { Guard } from './Guard';

export const guard = (): Guard => container.resolve(Guard);
